import { VStack } from "@gluestack-ui/themed";
import { MenuActionsList } from "@repo/core/components/layout/MenuActionsList";
import { CancelTransactionOptionsController } from "./controller";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { StatusBarVariantEnum } from "@repo/core/components/layout/StatusBar/types";

const CancelTransactionOptions = () => {
  const { isMobile, menuActionItems } = CancelTransactionOptionsController();

  return (
    <Scaffolds.Root
      showHeader={false}
      statusBarVariant={StatusBarVariantEnum.STORE_SELECT}
    >
      <Scaffolds.StoreSelect title="Cancelamento" showConfirmStoreModal>
        <VStack
          space="lg"
          alignItems={isMobile ? "flex-start" : "center"}
          pt="$3"
          px={isMobile ? "$4" : "$6"}
          w="$full"
        >
          <MenuActionsList
            title="Tipo de transaçao que deseja cancelar"
            menuItems={menuActionItems}
          />
        </VStack>
      </Scaffolds.StoreSelect>
    </Scaffolds.Root>
  );
};
export default CancelTransactionOptions;
